import $store from './index';
import MediaModule from '../../modules/MediaModule/store/media.module';
import UserModule from '../../modules/UserModule/store/user.module';

/**
 * @return {void}
 */
export const registerMediaModule = () => $store.registerModule('media', MediaModule);

/**
 * @return {void}
 */
export const registerUserModule = () => $store.registerModule('user', UserModule);
